import React from 'react';
import { schedulePreviews } from '../../data/mockSubscriptionSchedules';
import type { SchedulePreviewId } from '../../data/mockSubscriptionSchedules';
interface BillingSchedulePreviewControlProps {
  previewId: SchedulePreviewId;
  onSelect: (id: SchedulePreviewId) => void;
  firstPackHeld: boolean;
  onFirstPackHeldChange: (held: boolean) => void;
}

// Prototype-only switcher, not part of the merchant experience
export function BillingSchedulePreviewControl({
  previewId,
  onSelect,
  firstPackHeld,
  onFirstPackHeldChange
}: BillingSchedulePreviewControlProps) {
  return <div className="flex flex-col gap-2 mb-4 sm:flex-row sm:flex-wrap sm:items-center" data-id="element-4824" data-mp="2rr3rqxkqhuag">
      <span className="text-[13px] font-medium text-[#64748B]" data-id="element-4825" data-mp="2wpykoscf0z8a">
        Pack schedule:
      </span>
      <div className="inline-flex w-fit flex-wrap rounded-md border border-[#CBD5E1] bg-white p-1" role="group" aria-label="Prototype pack schedule preview" data-id="element-4826" data-mp="30rju23pqqvdq">
        {schedulePreviews.map(preview => <button key={preview.id} type="button" onClick={() => onSelect(preview.id)} aria-pressed={previewId === preview.id} className={`h-[32px] px-3 rounded-[4px] text-[13px] font-medium transition-colors ${previewId === preview.id ? 'bg-[#E0F2FE] text-[#0EA5E9]' : 'text-[#64748B] hover:text-[#0F172A]'}`} data-id="element-4827" data-mp="35oa70i691aux">
            {preview.label}
          </button>)}
      </div>
      {previewId === 'releaseDates' && <label className="inline-flex items-center gap-2 text-[13px] text-[#475569] cursor-pointer" data-id="element-4828" data-mp="13ax58au689l">
          <input type="checkbox" checked={firstPackHeld} onChange={e => onFirstPackHeldChange(e.target.checked)} className="w-4 h-4 accent-[#0EA5E9] cursor-pointer" data-id="element-4829" data-mp="tpndkmer1p4l" />
          First pack held for release
        </label>}
      <span className="text-[12px] text-[#94A3B8]" data-id="element-4830" data-mp="k0c7l8n5t0kx">Prototype control</span>
    </div>;
}